import MobileHeader from "./mainscreen/header/MobileHeader";
import Footer from "./mainscreen/footer/Footer";
import React, { useEffect, useState } from "react";
import { IMainScreenProps, MainScreenContainer } from "./MainScreenContainer";
import { useParams } from "react-router-dom";
import { Modal } from "@material-ui/core";
import PromocodeActivationAlert from "./promocode/PromocodeActivationAlert";
import { localStorageKey } from "./mainscreen/items/promo/PromoItem";
import { getMobileAppPromo } from "./helpers/getMobileAppPromo";
import { openPassport } from "./mainscreen/header/Avatar";
import YandexProjectLogo from "./mainscreen/footer/YandexProjectLogo";
import ContestPromo from "./mainscreen/ContestPromo";

export default function MainScreenMobileContainer(props: IMainScreenProps) {
    let session = props.session
    let b2cInfo = props.b2cInfo
    let contest = b2cInfo.contest

    return <div className="Main_screen_mobile_container">
        <MobileHeader avatarUrl={(session?.user.passport.avatar_url ?? "") + "/islands-68"}
            constants={b2cInfo.constants} />
        {props.sections}
        {contest != null &&
            <ContestPromo contest={contest} isMobile={props.isMobile} />
        }
        {!props.isLight && <Footer mobile={props.isMobile}
            footer={b2cInfo.footer}
            city={props.city}
            cities={b2cInfo.cities}
            constants={b2cInfo.constants}
            onSelected={(c) => props.setCity(c)}
        />}
        <div className="Footer_copyright_mobile">
            <div className="Footer_copyright_mobile__menu">
                <a href={window.location.href}>Каршеринг</a>
                <a href={b2cInfo.constants.podpiska_link} target="_blank">Подписка</a>
                <a href={b2cInfo.constants.b2b_link} target="_blank">Для бизнеса</a>
            </div>
            <div className="Footer_copyright_mobile__copyright">
                <div className="Footer_copyright_left">
                    © 2017—2024
                </div>
                <div className="Footer_copyright_right">
                    Яндекс Драйв
                </div>
            </div>
            <div style={{ marginBottom: "40px" }}>
                <YandexProjectLogo />
            </div>
        </div>
    </div>
}

export function MainScreenMobileContainerWithPromo(props: IMainScreenProps) {
    console.log("b")
    let { code } = useParams<{ code: string }>();

    const [openPromo, setOpenPromo] = useState(false);
    const handleOpenPromo = () => {
        setOpenPromo(true);
    };
    const handleClose = () => {
        setOpenPromo(false);
    };

    let session = props.session
    let appPromo = getMobileAppPromo(props.b2cInfo.constants)

    useEffect(() => {
        handleOpenPromo()
    }, [])

    useEffect(() => {
        if (session == null) {
            openPassport()
        }
    }, [session])

    return <div>
        <MainScreenMobileContainer {...props} />
        {
            (session != null) && <Modal
                open={openPromo}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <PromocodeActivationAlert
                    onRegister={() => {
                        window.open(appPromo.link, "_blank")
                        setOpenPromo(false)
                    }}
                    onClose={() => setOpenPromo(false)}
                    promocode={code}
                    session={session}
                    isMobile={true}
                />
            </Modal>
        }
    </div>
}
